import { Component, OnInit, ChangeDetectionStrategy, ViewChild, TemplateRef, Input, Injector, ComponentRef, ChangeDetectorRef } from '@angular/core';
import { JobService } from "../services/jobs/job.service";
import { LabourJobService } from '../labour-job/labour-job.service';
import { UtilityService } from '../services/utility.service';
import { Router, NavigationExtras } from "@angular/router";
import * as _ from 'lodash';
import { MatDialogRef, MAT_DIALOG_DATA, MatSnackBar } from '@angular/material';

import {
  isSameDay,
  isSameMonth
} from 'date-fns';
import { Subject, Observable } from 'rxjs';
import {
  CalendarEvent,
  CalendarEventAction,
  CalendarEventTimesChangedEvent,
  CalendarView
} from 'angular-calendar';
import { MatDialog } from "@angular/material";
import { timeStamp } from 'console';
import { resolve } from 'url';

const colors: any = {
  red: {
    primary: '#ad2121',
    secondary: '#FAE3E3'
  },
  blue: {
    primary: '#1e90ff',
    secondary: '#D1E8FF'
  },
  yellow: {
    primary: '#e3bc08',
    secondary: '#FDF1BA'
  }
};


@Component({
  selector: 'app-scheduler',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './scheduler.component.html',
  styleUrls: ['./scheduler.component.scss']
})
export class SchedulerComponent implements OnInit {

  @ViewChild('modalContent', { static: true }) modalContent: TemplateRef<any>;
  @Input('mwlCalendarTooltip') contents: string;


  view: CalendarView = CalendarView.Month;
  jobs = []
  //  jobs = [{ client: "SKUK", value: 1 }, { client: "Shipley", value: 2 }, { client: "FOC", value: 3 }, { client: "Shipley", value: 4 }];
  CalendarView = CalendarView;
  events = [];
  viewDate: Date = new Date();
  jobId;
  viewDropdown: Boolean = true;
  currentUser;
  user;

  jobsForFilter;
  isInformation = false
  modalData: {
    action: string;
    event: CalendarEvent;
  };

  allevents = []

  actions: CalendarEventAction[] = [
    {
      label: '<i class="fa fa-fw fa-pencil"></i>',
      onClick: ({ event }: { event: CalendarEvent }): void => {
        this.handleEvent('Edited', event);
      }
    },
    {
      label: '<i class="fa fa-fw fa-times"></i>',
      onClick: ({ event }: { event: CalendarEvent }): void => {
        this.events = this.events.filter(iEvent => iEvent !== event);
        this.handleEvent('Deleted', event);
      }
    }
  ];

  refresh: Subject<any> = new Subject();


  externalEvents: CalendarEvent[] = []

  activeDayIsOpen: boolean = true;
  job: any;
  selectedJob;
  jobsForModal: any;
  dialogref = null;
  // allevents = [];
  loading = false;
  jobsLength = 0;
  displayTitle: Boolean = true;
  newJobdate: any;
  oneJobFound: Boolean = false;

  constructor(
    private _jobService: JobService,
    private router: Router,
    private injector: Injector,
    public dialog: MatDialog,
    public _snackBar: MatSnackBar,
    public dialogRef: MatDialogRef<any>,
    public _labourjobService: LabourJobService,
    public _cd: ChangeDetectorRef,
    public _utilityService: UtilityService
  ) {
    this.user = JSON.parse(localStorage.getItem('userRoles'))
    if (this.router.url.includes('/job/list') || this.router.url.includes('/client/view') || this.router.url.includes('/staff')) {
      this.jobsForModal = this.injector.get(MAT_DIALOG_DATA)
      this.dialogref = this.injector.get(MatDialogRef)
      this.displayTitle = false;
      console.log("IN IF CONDITION Of Constructor", this.jobsForModal);
    }
  }
  createNewJob() {
    let job = {
      title: "Add Training Job",
      start: new Date(),
      color: colors.yellow,
      draggable: true,
      allDay: true,
      jobType: "trainer"
    }
    this.externalEvents.push(job)
    let labourJob = {
      title: "Add Labour Job",
      start: new Date(),
      color: colors.yellow,
      draggable: true,
      allDay: true,
      jobType: "labour"
    }
    this.externalEvents.push(labourJob)
    let medicalJob = {
      title: "Add Medical Practitioner's Job",
      start: new Date(),
      color: colors.yellow,
      draggable: true,
      allDay: true,
      jobType: "mp"
    }
    this.externalEvents.push(medicalJob)
  }

  createNewMpJob() {
    let job = {
      title: "New Practitioner's Job",
      start: new Date(),
      color: colors.yellow,
      draggable: true,
      allDay: true
    }
    this.externalEvents.push(job)
  }
  eventDropped({
    event,
    newStart,
    newEnd,
    allDay
  }: CalendarEventTimesChangedEvent): void {

    event.start = new Date(newStart)

    // if (event.start > new Date()) {

    console.log("VALUE OF EXTERNAL EVENT", this.externalEvents, event);
    const externalIndex = this.externalEvents.indexOf(event);
    if (typeof allDay !== 'undefined') {
      event.allDay = allDay;
    }
    if (externalIndex > -1) {
      this.externalEvents.splice(externalIndex, 1);
      this.events.push(event);
    }

    event.start = newStart;
    if (newEnd) event.end = newEnd;

    console.log(' this.viewDate===>', this.viewDate);
    if (this.view === 'month') {
      this.viewDate = newStart;
      this.activeDayIsOpen = true;
    }
    // this.allevents.push(this.createEventObject(event));
    console.log("this.allevents", JSON.stringify(this.allevents, null, 2));

    console.log("this.allevent last", this.allevents[this.allevents.length - 1]);
    event.draggable = false;
    this.allevents = [...this.allevents, event];


    // console.log("allevents", this.allevents)

    console.log("AFTER EVENTS RESPOND", this.externalEvents);

    if (this.externalEvents.length < 1) {
      // if (this.externalEvents[0].title == 'Add Job') {
      this.createNewJob()
      // }
      // else {
      //   this.createNewMpJob;
      // }
    }
  }


  externalDrop(event) {
    console.log("external event dropped");
    if (this.externalEvents.indexOf(event) === -1) {
      this.events = this.events.filter(iEvent => iEvent !== event);
      this.externalEvents.push(event);
    }
  }

  dayClicked({ date, events }: { date: Date; events: CalendarEvent[] }): void {
    console.log("DAY CLICKED", date, events);
    this.newJobdate = date;

    if (isSameMonth(date, this.viewDate)) {
      if (
        (isSameDay(this.viewDate, date) && this.activeDayIsOpen === true) ||
        events.length === 0
      ) {
        this.activeDayIsOpen = false;
      } else {
        this.activeDayIsOpen = true;
      }
      this.viewDate = date;
    }
  }

  openDialog(someComponent, data = {}): Observable<any> {
    console.log('OPENDIALOG', 'DATA = ', data)
    const dialogRef = this.dialog.open(someComponent, { data, width: '1000px', height: '967px' });
    return dialogRef.afterClosed();
  }
  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
    });
  }


  // Model Opener
  handleEvent(action: string, event): void {
    console.log("Handling event", { action, event })
    if (event.jobid) {
      let temp = _.findIndex(this.jobs, function (o) { return o._id == event.jobid })
      let type;
      if (temp > -1) {
        type = this.jobs[temp].jobType
        if (type == 'mp') {
          this.router.navigate(['/job/mpjob/' + event.jobid]);
        } else {
          this.router.navigate(['/job/view/' + event.jobid]);
        }
      }

      if (this.dialogref != null) {
        this.dialogref.close();
        this.displayTitle = false;
      }
    }
    else if (event.title == "No Job Scheduled Today") {
      console.log("NOT SCHEDULED")
    }
    else if (event.title == "New Trainer's Job") {

      console.log('event In Scheduler====>', event);

      let navigationExtras: NavigationExtras = {
        state: {
          job: event
        }
      };
      this.router.navigateByUrl('/job/add-job', navigationExtras);

    } else {
      let navigationExtras: NavigationExtras = {
        state: {
          job: event
        }
      };
      this.router.navigateByUrl('/job/addmpjob', navigationExtras);
    }
  }


  handleEventforLabourjob(action: string, event) {
    console.log("THIS IS THE EVENT", event)
    if (event && event.jobid) {
      if (event && event.jobType === 'labour') {
        this.router.navigate(['/labour-job/view/' + event.jobid])
      } else if (event && event.jobType === 'trainer') {
        this.router.navigate(['/job/view/' + event.jobid]);
      } else if (event && event.jobType === 'mp') {
        this.router.navigate(['/job/mpjob/' + event.jobid]);
      }
    } else {
      if (event && event.jobType === 'labour') {
        this.router.navigate(['/labour-job/create'])
      } else if (event && event.jobType === 'trainer') {
        this.router.navigateByUrl('/job/add-job');
      } else if (event && event.jobType === 'mp') {
        this.router.navigateByUrl('/job/addmpjob');
      }
    }

    // if (event.title == 'Add Job') {
    //   console.log("ACTION OF CALENDAR CLICK", action, event);
    //   this.router.navigate(['/labour-job/create'])
    // }
    // if (event.title != "No Job Scheduled Today" && event.title != 'Add Job') {
    //   console.log("ACTION OF CALENDAR CLICK", action, event);
    //   this.router.navigate(['/labour-job/view/' + event.jobid])
    // }
  }

  addJobModel(event) {
    console.log("add job modal", event);

  }

  closeOpenMonthViewDay() {
    this.activeDayIsOpen = false;
  }

  todayClicked() {
    console.log('Today Clicked===>', this.viewDate);
    this.activeDayIsOpen = true;
  }



  ngOnInit() {
    $('#loader-wrapper-2').show()
    console.log("what is the view of job", this.view);

    console.log("this.loading", this.loading);
    this.createNewJob();
    // this.createNewMpJob();

    console.log("jobsForModal**********", this.jobsForModal);
    this.currentUser = JSON.parse(localStorage.currentUser);
    // this.user = JSON.parse(localStorage.getItem('userRoles'))

    console.log('Current User======>>', this.currentUser);

    if (this.router.url.includes('/jobs') || this.router.url.includes('/client') || this.router.url.includes('/staff')) {
      if (this.jobsForModal != undefined) {
        this.populateAllJobs(this.jobsForModal)
      }
      else if (this.jobsForModal == undefined) {
        this.getJobs()
      }
    }
    else {
      console.log("IN ELSE");
      // this.getJobs();
      // this.getLabourjobs()
      this.getCurrentUserJobs()
    }
    console.log("this.loading", this.loading);
  }
  // Utility
  createEventObject(obj) {
    // console.log("Creating Event object from = ", obj);
    // console.log("Type of Starting Date = ", typeof obj.startingDate);

    // console.log("obj.startingDate", typeof obj.startingDate)

    var newEvent = {
      start: new Date(obj.startingDate),
      title: obj.title,
      color: {
        primary: obj.color,
      },
      allDay: true,
      jobid: obj.jobid,
      jobType: obj.jobType
    }
    console.log("Event object created = ", newEvent);
    return newEvent;
  }


  makeEventsArrayForJob(job) {
    if (job.length < 1) return
    console.log("job in makeEvents", job);
    let dates = []
    if (this.user && this.user.isOperative) {
      let jobUser = job.operatives.find((x) => x.operatives._id === this.currentUser._id)
      console.log("THIS IS THE USER WITH JOB", jobUser)
      dates = jobUser.frequencyDates;
    }
    if (this.user && this.user.isAdmin) {
      if (job.operatives && job.operatives.length) {
        job.operatives.filter((x) => {
          if (x.frequencyDates && x.frequencyDates.length) {
            console.log("OPERATIVE FREQUENCY DATA", x.frequencyDates, x.operatives.name)
            for (let i = 0; i < x.frequencyDates.length; i++) {
              let obj = x.frequencyDates[i]
              obj['operativeName'] = x.operatives.name
              dates.push(obj)
            }
          }
        })
      }
    }
    console.log("THIS IS THE FINAL DATES WITH JOB", dates, job.jobTitle);
    var events = [];
    if (dates) {
      for (var i = 0; i < dates.length; i++) {
        let title
        if (this.user && this.user.isOperative) {
          title = `JobTitle: ${job.jobTitle} <br> Start Time: ${this.convertTime(job.startTime)} <br> End Time: ${this.convertTime(job.endTime)}`
        }
        if (this.user && this.user.isAdmin) {
          title = `JobTitle: ${job.jobTitle} <br> Operative Name: ${dates[i].operativeName} ( ${this.convertTime(job.startTime)} to ${this.convertTime(job.endTime)} )`
        }
        var newObj = this.createEventObject({
          startingDate: dates[i].date,
          title: title,
          color: job.clients[0].client.color || '#455a64',
          jobid: job._id,
          jobType: job.jobType
        })
        // console.log("dates[i] = ", new Date(dates[i]), "==", new Date(), dates[i] == new Date())
        if (new Date(dates[i].date).getDate() == new Date().getDate() && new Date(dates[i].date).getDay() == new Date().getDay() && new Date(dates[i].date).getFullYear() == new Date().getFullYear()) {
          this.oneJobFound = true
        }
        this.allevents.push(newObj);
        events.push(newObj);
        this.refresh.next();
        // this.allevents.push(events)
      }
    } else {
      var newObj = this.createEventObject({
        startingDate: job.startDate,
        title: job.jobTitle,
        color: job.jobColor,
        jobid: job._id,
        jobType: job.jobType
      })

      this.allevents.push(newObj);
      events.push(newObj);
      this.refresh.next();
    }

    console.log("Events = ", events);
    return events;
    // this.events = events;
  }



  makeEventsArrayForTrainingJobs(job) {
    if (job.length < 1) return
    console.log("job in makeEvents", job);

    var dates = job.singleJobDate;
    console.log("Dates", dates);

    let trainers = ['']
    if (job.instructors) {
      job.instructors.forEach(el => {
        console.log('name', el.name)
        trainers.push(el.name)
      })
    } else if (job.mps) {
      job.mps.forEach(el => {
        console.log('name', el.name)
        trainers.push(el.name)
      })
    }
    console.log("Processing Job with dates = ", job.title);
    let tempLocation
    if (job.location && job.location.title) {
      tempLocation = " - " + job.location.title
    }
    else {
      tempLocation = ''
    }
    var events = [];
    if (dates) {
      for (var i = 0; i < dates.length; i++) {

        var newObj = this.createEventObject({
          startingDate: dates[i].date,
          title: job.title + tempLocation + trainers.join(', '),
          color: job.course && job.course.color ? job.course.color : job.color,
          jobid: job._id,
          jobType: job.jobType
        })
        // console.log("dates[i] = ", new Date(dates[i]), "==", new Date(), dates[i] == new Date())
        if (new Date(dates[i].date).getDate() == new Date().getDate() && new Date(dates[i].date).getDay() == new Date().getDay() && new Date(dates[i].date).getFullYear() == new Date().getFullYear()) {
          this.oneJobFound = true
        }
        this.allevents.push(newObj);
        events.push(newObj);
        this.refresh.next();
        // this.allevents.push(events)
      }
    } else {
      var newObj = this.createEventObject({
        startingDate: job.startingDate,
        title: job.title + tempLocation + trainers.join(', '),
        color: job.color,
        jobid: job._id,
        jobType: job.jobType
      })

      this.allevents.push(newObj);
      events.push(newObj);
      this.refresh.next();
    }

    console.log("Events = ", events);
    return events;
  }

  convertTime(time) {
    let tempTime = time.split(':')
    let hour = tempTime[0]
    let miute = tempTime[1]
    return `${(hour % 12 < 10 ? '0' : '') + hour % 12} : ${miute}  ${hour < 12 ? 'AM' : 'PM'}`
  }


  populateAllJobs(jobs) {
    // this.loading = true
    return new Promise((resolve) => {
      for (var i = 0; i < jobs.length; i++) {
        console.log("IN FOR LOOP");
        if (jobs[i] && jobs[i].jobType === 'labour') {
          var events = this.makeEventsArrayForJob(jobs[i]);
        }
        if (jobs[i] && (jobs[i].jobType === 'trainer' || jobs[i].jobType === 'mp')) {
          // var events = this.makeEventsArrayForJob(jobs[i]);
          console.log("THIS IS FOR TRAINER AND MEDICAL JOB", jobs[i]);
          let tempEvent = this.makeEventsArrayForTrainingJobs(jobs[i]);
        }
      }
      resolve(events)
      console.log("After for loop", this.allevents);
      this.jobsLength = jobs.length
      console.log("In populate allJobs", this.loading, this.jobsLength);
    }).then(() => {
      $('#loader-wrapper-2').hide()
      if (this.oneJobFound == true) {
        console.log("ONE JOB FOUND")
      }
      else {
        let newObj = {
          start: new Date(),
          title: 'No Job Scheduled Today'
        }
        this.allevents.push(newObj)
        this.refresh.next()
      }
      this.loading = false;
    })
    // this.loading = false;
    // console.log("PopulateAllJobs Called with jobs = ", this.loading);

  }
  resetEvents() {
    this.events = [];
  }

  switchToNewView() {
    if (this.router.url.includes('/dashboard')) {
      this.dialogRef.close();
    }
    this.router.navigateByUrl('/scheduler/planner')
  }

  mouseHover(event) {
    // console.log("MOUSE HOVER EVENT", event);
    // this._utilityService.commonDialogBoxOpen(InformationModalComponent)
    this.isInformation = true

  }

  mouseLeave(event) {
    // console.log("WHEN MOUSE LEAVE", event);
    this.isInformation = false
  }


  async getCurrentUserJobs() {
    console.log("CURRENT USER DATA", this.currentUser)
    const trainingJobs = await this.getJobs()
    if (this.user && (this.user.isAdmin || this.user.isOperative)) {
      const labourJobs = await this.getLabourjobs()
      console.log("LABOUR JOBS DATA", labourJobs)
    }
    console.log("TRAINING JOB DATA", trainingJobs)
    console.log("ALL JOBS DATA", this.jobs)
    if (this.jobs && this.jobs.length) {
      this.populateAllJobs(this.jobs)
    }
  }

  // APIs
  getJobs() {
    return new Promise((resolve, reject) => {

      this._jobService.getJobs().subscribe(jobs => {
        $('#loader-wrapper-2').hide()
        this.jobs = this.jobs.concat(jobs['finalJobArray'] ? jobs['finalJobArray'] : jobs)
        resolve(jobs)
        // if (this.jobs && this.jobs.length) {
        //   this.populateAllJobs(this.jobs)
        // }
      }, err => {
        console.error(err);
      })
    })
    // $('#loader-wrapper').hide()
  }

  getLabourjobs() {
    return new Promise((resolve, reject) => {
      // this.loading = true
      this._labourjobService.getLabourjoblist().subscribe((jobList) => {
        this.loading = false
        // this.jobs = jobList.displayJobs
        if (jobList.displayJobs) {
          this.jobs = this.jobs.concat(jobList.displayJobs)
        }
        resolve(jobList)
        console.log("JOB LIST OF LABOUR", jobList, this.jobs.length);
        // if (this.jobs && this.jobs.length) {
        //   this.populateAllJobs(this.jobs)
        // } else {
        //   let newObj = {
        //     start: new Date(),
        //     title: 'No Job Scheduled Today'
        //   }
        //   this.allevents.push(newObj)
        //   this.refresh.next()
        // }
        // this.updateData(this.jobList)
        // this._cd.detectChanges()
      }, err => {
        console.log("ERROR WHILE GET JOB LIST", err);
        this.loading = false
      })
    })
  }


}
